module.exports = __webpack_public_path__ + "static/img/logo_white.d80a3e1a.png";